import React from 'react';

export const FundsSummaryIcon = () => {
  return (
    <svg
      width='48'
      height='48'
      viewBox='0 0 48 48'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <circle
        cx='24'
        cy='24'
        r='23.75'
        fill='#FEFAEC'
        stroke='#FCEEC0'
        strokeWidth='0.5'
      />
      <g clipPath='url(#clip0_15036_24673)'>
        <path
          d='M24 12C17.373 12 12 17.373 12 24C12 30.627 17.373 36 24 36C30.627 36 36 30.627 36 24C36 17.373 30.627 12 24 12ZM26.592 30.768C25.968 31.008 25.464 31.2 25.104 31.344C24.732 31.466 24.303 31.537 23.858 31.537C23.832 31.537 23.806 31.537 23.781 31.536H23.785C23.74 31.539 23.688 31.54 23.635 31.54C23.016 31.54 22.448 31.321 22.005 30.956L22.009 30.96C21.625 30.628 21.384 30.14 21.384 29.597C21.384 29.579 21.384 29.56 21.385 29.542V29.545C21.377 29.444 21.373 29.327 21.373 29.209C21.373 29.091 21.377 28.974 21.386 28.858L21.385 28.873C21.385 28.633 21.457 28.393 21.529 28.081L22.321 25.321C22.393 25.033 22.441 24.793 22.489 24.553C22.545 24.36 22.579 24.138 22.585 23.908V23.905C22.588 23.877 22.59 23.844 22.59 23.81C22.59 23.561 22.497 23.333 22.344 23.16L22.345 23.161C22.149 23.021 21.904 22.938 21.64 22.938C21.592 22.938 21.546 22.941 21.499 22.946L21.505 22.945C21.281 22.95 21.067 22.985 20.864 23.045L20.881 23.041L20.329 23.233L20.545 22.369C21.049 22.153 21.553 21.985 22.033 21.817C22.442 21.68 22.912 21.601 23.401 21.601C23.409 21.601 23.418 21.601 23.426 21.601H23.425C23.474 21.598 23.531 21.596 23.588 21.596C24.191 21.596 24.746 21.806 25.182 22.157L25.177 22.153C25.506 22.486 25.709 22.945 25.709 23.45C25.709 23.492 25.708 23.533 25.705 23.574V23.568C25.705 23.712 25.705 23.904 25.705 24.216C25.681 24.526 25.63 24.812 25.553 25.088L25.561 25.056L24.769 27.816C24.721 28.04 24.665 28.296 24.601 28.584C24.564 28.773 24.538 28.996 24.529 29.223V29.232C24.525 29.263 24.523 29.299 24.523 29.335C24.523 29.582 24.616 29.807 24.769 29.977L24.768 29.976C24.989 30.113 25.257 30.195 25.544 30.195C25.575 30.195 25.605 30.194 25.636 30.192H25.632C25.866 30.184 26.088 30.15 26.3 30.091L26.28 30.096C26.485 30.04 26.66 29.975 26.828 29.895L26.808 29.904L26.592 30.768ZM26.448 19.512C26.115 19.81 25.672 19.992 25.187 19.992C25.175 19.992 25.163 19.992 25.15 19.992H25.152C25.138 19.992 25.122 19.993 25.105 19.993C24.604 19.993 24.148 19.801 23.806 19.487L23.807 19.488C23.466 19.183 23.253 18.743 23.253 18.252C23.253 17.761 23.466 17.321 23.805 17.017L23.807 17.016C24.134 16.731 24.564 16.556 25.036 16.556C25.077 16.556 25.117 16.557 25.157 16.56H25.152C25.153 16.56 25.154 16.56 25.155 16.56C25.659 16.56 26.115 16.762 26.449 17.088C26.783 17.396 26.991 17.836 26.991 18.324C26.991 18.812 26.783 19.252 26.45 19.559L26.449 19.56L26.448 19.512Z'
          fill='#F3C117'
        />
      </g>
      <defs>
        <clipPath id='clip0_15036_24673'>
          <rect
            width='24'
            height='24'
            fill='white'
            transform='translate(12 12)'
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const ClearFileUploadCross = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
    >
      <g clipPath='url(#clip0_9327_39942)'>
        <path
          d='M8 0C3.6 0 0 3.6 0 8C0 12.4 3.6 16 8 16C12.4 16 16 12.4 16 8C16 3.6 12.4 0 8 0ZM10.72 9.84C10.96 10.08 10.96 10.48 10.72 10.72C10.64 10.8 10.48 10.88 10.32 10.88C10.16 10.88 10 10.8 9.92 10.72L8 8.88L6.16 10.72C6.08 10.8 5.92 10.88 5.76 10.88C5.6 10.88 5.44 10.8 5.36 10.72C5.12 10.48 5.12 10.08 5.36 9.84L7.12 8L5.28 6.16C5.04 5.92 5.04 5.52 5.28 5.28C5.52 5.04 5.92 5.04 6.16 5.28L8 7.12L9.84 5.28C10.08 5.04 10.48 5.04 10.72 5.28C10.96 5.52 10.96 5.92 10.72 6.16L8.88 8L10.72 9.84Z'
          fill='#AFB4C0'
        />
      </g>
      <defs>
        <clipPath id='clip0_9327_39942'>
          <rect width='16' height='16' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export const FileSVG = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='18'
      height='18'
      viewBox='0 0 18 18'
      fill='none'
    >
      <path
        d='M15.75 6V15.7449C15.75 16.1626 15.4164 16.5 15.0049 16.5H2.99504C2.5837 16.5 2.24999 16.167 2.24999 15.7561V2.24385C2.24999 1.84148 2.58652 1.5 3.00165 1.5H11.2476L15.75 6ZM14.25 6.75H10.5V3H3.74999V15H14.25V6.75ZM5.99999 5.25H8.24999V6.75H5.99999V5.25ZM5.99999 8.25H12V9.75H5.99999V8.25ZM5.99999 11.25H12V12.75H5.99999V11.25Z'
        fill='#EF4F5F'
      />
    </svg>
  );
};

export const InfoLineIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
    >
      <g clipPath='url(#clip0_14471_26985)'>
        <path
          d='M9.808 12.192C9.424 12.336 9.104 12.464 8.88 12.544C8.66 12.616 8.40667 12.6573 8.144 12.6573C8.116 12.6573 8.088 12.6567 8.06 12.656H8.064C8.03067 12.6587 7.99133 12.66 7.95133 12.66C7.576 12.66 7.23067 12.532 6.956 12.3173L6.95933 12.32C6.714 12.1133 6.55867 11.8053 6.55867 11.4613C6.55867 11.448 6.55867 11.4347 6.55933 11.422V11.424C6.554 11.362 6.55133 11.2893 6.55133 11.216C6.55133 11.1427 6.554 11.07 6.56 10.9987L6.55933 11.008C6.55933 10.864 6.60733 10.704 6.65533 10.512L7.13533 8.784C7.18333 8.624 7.21533 8.464 7.24733 8.304C7.27467 8.18533 7.292 8.04733 7.29533 7.906V7.904C7.29867 7.88 7.30067 7.85267 7.30067 7.82533C7.30067 7.67933 7.25067 7.54533 7.16667 7.43867L7.168 7.44C7.04667 7.356 6.89667 7.306 6.73467 7.306C6.70133 7.306 6.66867 7.308 6.636 7.312L6.64 7.31133C6.63267 7.31133 6.624 7.31133 6.61467 7.31133C6.48667 7.31133 6.36333 7.32867 6.246 7.362L6.25533 7.36L5.90333 7.488L6.09533 6.96C6.41533 6.832 6.73533 6.72 7.02333 6.624C7.272 6.54333 7.558 6.49667 7.85467 6.496H7.85533C7.864 6.496 7.874 6.496 7.88467 6.496C8.276 6.496 8.63467 6.63533 8.914 6.86667L8.91133 6.86467C9.14733 7.074 9.296 7.378 9.296 7.71667C9.296 7.72667 9.296 7.73667 9.29533 7.74667V7.74533C9.29533 7.82533 9.29533 7.95333 9.29533 8.14533C9.27933 8.34 9.24533 8.52 9.19467 8.69267L9.19933 8.67333L8.70333 10.3853C8.66867 10.512 8.63533 10.6747 8.61067 10.84L8.60733 10.8653C8.582 10.988 8.56467 11.1307 8.55933 11.2767V11.2813C8.55667 11.3027 8.55467 11.328 8.55467 11.3533C8.55467 11.504 8.61067 11.6413 8.70333 11.746L8.70267 11.7453C8.82867 11.8193 8.98067 11.8633 9.14333 11.8633C9.18 11.8633 9.216 11.8613 9.25133 11.8567L9.24733 11.8573C9.25867 11.8573 9.272 11.858 9.28533 11.858C9.414 11.858 9.53867 11.84 9.65733 11.8073L9.64733 11.8093C9.772 11.7767 9.878 11.7387 9.98 11.692L9.96733 11.6973L9.808 12.192ZM9.728 5.184C9.512 5.38333 9.222 5.506 8.904 5.506C8.586 5.506 8.296 5.384 8.07933 5.18333L8.08 5.184C7.87667 4.994 7.75 4.72333 7.75 4.424C7.75 4.12467 7.87667 3.854 8.07933 3.66467L8.08 3.664C8.296 3.46467 8.586 3.342 8.904 3.342C9.222 3.342 9.512 3.464 9.72867 3.66467L9.728 3.664C9.93133 3.854 10.058 4.12467 10.058 4.424C10.058 4.72333 9.93133 4.994 9.72867 5.18333L9.728 5.184ZM8 0C3.582 0 0 3.582 0 8C0 12.418 3.582 16 8 16C12.418 16 16 12.418 16 8C16 3.582 12.418 0 8 0ZM8 14.864C4.20933 14.864 1.136 11.7907 1.136 8C1.136 4.20933 4.20933 1.136 8 1.136C11.7907 1.136 14.864 4.20933 14.864 8C14.864 11.7907 11.7907 14.864 8 14.864Z'
          fill='#9197A6'
        />
      </g>
      <defs>
        <clipPath id='clip0_14471_26985'>
          <rect width='16' height='16' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export const OnlinePaymentsIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='18'
      height='18'
      viewBox='0 0 18 18'
      fill='none'
    >
      <g clipPath='url(#clip0_17895_30477)'>
        <path
          d='M17.244 8.244C16.8345 8.25375 16.506 8.58825 16.506 9V14.994C16.506 14.9993 16.506 15.006 16.506 15.012C16.506 15.837 15.837 16.506 15.012 16.506C15.006 16.506 14.9992 16.506 14.9932 16.506H14.994H3.006C3.00075 16.506 2.994 16.506 2.988 16.506C2.163 16.506 1.494 15.837 1.494 15.012C1.494 15.006 1.494 14.9992 1.494 14.9932V14.994V3.006C1.494 3.00075 1.494 2.994 1.494 2.988C1.494 2.163 2.163 1.494 2.988 1.494C2.994 1.494 3.00075 1.494 3.00675 1.494H3.006H9C9.3645 1.4355 9.63975 1.1235 9.63975 0.747C9.63975 0.3705 9.3645 0.0585 9.0045 0.00075L9 0H3.006C1.3455 0 0 1.3455 0 3.006V14.994C0 16.6545 1.3455 18 3.006 18H14.994C16.6545 18 18 16.6545 18 14.994V9C18 8.58225 17.6618 8.244 17.244 8.244ZM12.15 4.086L13.662 2.592V6.93C13.7205 7.2945 14.0325 7.56975 14.409 7.56975C14.7855 7.56975 15.0975 7.2945 15.1553 6.9345L15.156 6.93V2.556L16.704 4.086C16.8405 4.221 17.028 4.30425 17.235 4.30425C17.442 4.30425 17.6295 4.221 17.766 4.086C17.901 3.9495 17.9842 3.762 17.9842 3.555C17.9842 3.348 17.901 3.1605 17.766 3.024L14.994 0.216C14.8598 0.084 14.6753 0.00225 14.4728 0H14.472C14.2687 0.00225 14.0843 0.084 13.95 0.216L11.088 3.006C10.986 3.1335 10.9245 3.297 10.9245 3.4755C10.9245 3.89325 11.2628 4.2315 11.6805 4.2315C11.8583 4.2315 12.0225 4.17 12.1515 4.06725L12.15 4.06875V4.086ZM11.25 6.408V5.184H4.122V6.534H5.58C6.678 6.534 7.38 6.948 7.596 7.74H4.122V8.91H7.596C7.38 9.756 6.48 10.206 5.256 10.206H4.122V11.034L7.596 15.372H9.684L6.444 11.376C7.8705 11.259 9.04125 10.2825 9.44325 8.97L9.45 8.946H11.25V7.74H9.45C9.39225 7.22625 9.132 6.7815 8.75175 6.483L8.748 6.48V6.408H11.25Z'
          fill='white'
        />
      </g>
      <defs>
        <clipPath id='clip0_17895_30477'>
          <rect width='18' height='18' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export const ShareUTRIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='18'
      height='18'
      viewBox='0 0 18 18'
      fill='none'
    >
      <path
        d='M7.5 2.25V3.75H3.75V14.25H14.25V10.5H15.75V15C15.75 15.4142 15.4142 15.75 15 15.75H3C2.58579 15.75 2.25 15.4142 2.25 15V3C2.25 2.58579 2.58579 2.25 3 2.25H7.5ZM13.1894 3.75H9.75V2.25H15.75V8.25H14.25V4.81066L9 10.0606L7.93935 9L13.1894 3.75Z'
        fill='#EF4F5F'
      />
    </svg>
  );
};

export const DisabledShareUTRIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='14'
      height='14'
      viewBox='0 0 14 14'
      fill='none'
    >
      <path
        d='M5.5 0.25V1.75H1.75V12.25H12.25V8.5H13.75V13C13.75 13.4142 13.4142 13.75 13 13.75H1C0.58579 13.75 0.25 13.4142 0.25 13V1C0.25 0.58579 0.58579 0.25 1 0.25H5.5ZM11.1894 1.75H7.75V0.25H13.75V6.25H12.25V2.81066L7 8.06065L5.93935 7L11.1894 1.75Z'
        fill='#9197A6'
      />
    </svg>
  );
};

export const ThreeDotIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
    >
      <path
        d='M6.6665 3.33333C6.6665 2.6 7.2665 2 7.99984 2C8.73317 2 9.33317 2.6 9.33317 3.33333C9.33317 4.06667 8.73317 4.66667 7.99984 4.66667C7.2665 4.66667 6.6665 4.06667 6.6665 3.33333ZM7.99984 6.66667C7.2665 6.66667 6.6665 7.26667 6.6665 8C6.6665 8.73333 7.2665 9.33333 7.99984 9.33333C8.73317 9.33333 9.33317 8.73333 9.33317 8C9.33317 7.26667 8.73317 6.66667 7.99984 6.66667ZM7.99984 11.3333C7.2665 11.3333 6.6665 11.9333 6.6665 12.6667C6.6665 13.4 7.2665 14 7.99984 14C8.73317 14 9.33317 13.4 9.33317 12.6667C9.33317 11.9333 8.73317 11.3333 7.99984 11.3333Z'
        fill='#767C8F'
      />
    </svg>
  );
};

export const RefreshIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
    >
      <g clipPath='url(#clip0_17895_30474)'>
        <path
          d='M2.36795 8.12807C2.28062 8.16874 2.17795 8.19273 2.07062 8.19273C2.06262 8.19273 2.05462 8.19273 2.04729 8.19207H2.04862C2.04862 8.19207 2.04795 8.19207 2.04729 8.19207C1.79329 8.19207 1.57262 8.0514 1.45795 7.8434L1.45595 7.84007L0.0799531 5.16807C0.0312865 5.0774 0.00195312 4.96873 0.00195312 4.85407C0.00195312 4.59473 0.14862 4.3694 0.363953 4.2574L0.367953 4.2554C0.455953 4.21073 0.559286 4.18407 0.669286 4.18407C0.925953 4.18407 1.14929 4.32807 1.26262 4.54007L1.26462 4.5434L1.80862 5.5994C2.79329 3.0654 5.21262 1.30273 8.04329 1.30273C10.5133 1.30273 12.67 2.64473 13.8233 4.6394L13.8406 4.6714C13.9126 4.77673 13.9553 4.90673 13.9553 5.04673C13.9553 5.41807 13.6546 5.71873 13.2833 5.71873C13.014 5.71873 12.782 5.56007 12.6746 5.3314L12.6726 5.3274C11.7253 3.7274 10.0086 2.67073 8.04462 2.67073C5.72662 2.67073 3.75195 4.14207 3.00462 6.20207L2.99262 6.2394L2.94462 6.3194L4.43262 5.5514C4.54062 5.47473 4.67462 5.42873 4.81995 5.42873C5.19129 5.42873 5.49195 5.7294 5.49195 6.10073C5.49195 6.39273 5.30595 6.6414 5.04595 6.73407L5.04129 6.7354L2.36795 8.12807ZM15.92 10.8321L14.544 8.17607C14.4293 7.96073 14.206 7.81673 13.9493 7.81673C13.8393 7.81673 13.736 7.8434 13.644 7.89007L13.648 7.88807L10.976 9.28007C10.7113 9.37407 10.5246 9.62273 10.5246 9.91473C10.5246 10.2861 10.8253 10.5867 11.1966 10.5867C11.3413 10.5867 11.476 10.5407 11.586 10.4627L11.584 10.4641L13.072 9.68007C13.0553 9.7114 13.0393 9.73807 13.022 9.76274L13.024 9.76007C12.2693 11.8661 10.2906 13.3454 7.96595 13.3454C5.99529 13.3454 4.27262 12.2814 3.34129 10.6967L3.32729 10.6714C3.22995 10.4121 2.98462 10.2314 2.69662 10.2314C2.32529 10.2314 2.02462 10.5321 2.02462 10.9034C2.02462 11.0647 2.08129 11.2127 2.17595 11.3287L2.17529 11.3274C3.34329 13.3634 5.50529 14.7134 7.98195 14.7134C10.8193 14.7134 13.2433 12.9421 14.208 10.4454L14.2233 10.4001L14.7673 11.4721C14.8833 11.6834 15.1046 11.8241 15.358 11.8241C15.3586 11.8241 15.3586 11.8241 15.3593 11.8241C15.3646 11.8241 15.3706 11.8241 15.3766 11.8241C15.4806 11.8241 15.5793 11.8001 15.6673 11.7581L15.6633 11.7601C15.872 11.6434 16.0113 11.4234 16.0113 11.1714C16.0113 11.0461 15.9773 10.9294 15.918 10.8287L15.92 10.8321Z'
          fill='#1C1C1C'
        />
      </g>
      <defs>
        <clipPath id='clip0_17895_30474'>
          <rect width='16' height='16' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export const DownloadInvoice = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='18'
      height='16'
      viewBox='0 0 18 16'
      fill='none'
    >
      <path
        d='M10.1242 8.00039C10.4992 8.00039 10.7992 7.70039 10.7992 7.32539C10.7992 7.25039 10.7992 7.17539 10.7242 7.10039C10.6492 6.87539 10.4242 6.65039 10.1242 6.65039H6.37422C5.99922 6.65039 5.69922 6.95039 5.69922 7.32539C5.69922 7.70039 5.99922 8.00039 6.37422 8.00039H9.37422H10.1242Z'
        fill='#EF4F5F'
      />
      <path
        d='M6.37422 9.27539C5.99922 9.27539 5.69922 9.57539 5.69922 9.95039C5.69922 10.3254 5.99922 10.6254 6.37422 10.6254H8.39922C8.77422 10.6254 9.07422 10.3254 9.07422 9.95039C9.07422 9.57539 8.77422 9.27539 8.39922 9.27539H6.37422Z'
        fill='#EF4F5F'
      />
      <path
        d='M6.37422 5.44961H10.1242C10.4992 5.44961 10.7992 5.14961 10.7992 4.77461C10.7992 4.39961 10.4992 4.09961 10.1242 4.09961H6.37422C5.99922 4.09961 5.69922 4.39961 5.69922 4.77461C5.69922 5.14961 6.07422 5.44961 6.37422 5.44961Z'
        fill='#EF4F5F'
      />
      <path
        d='M13.8 7.10039H13.725V2.82539C13.725 1.40039 12.6 0.275391 11.175 0.275391H3.45H3.075H2.55C1.125 0.275391 0 1.40039 0 2.82539V7.10039C0 8.52539 1.125 9.65039 2.55 9.65039H3.075V13.1004C3.075 14.5254 4.2 15.6504 5.625 15.6504H9.45H11.175C11.55 15.6504 11.925 15.5754 12.3 15.4254C11.7 15.2004 11.175 14.8254 10.725 14.3754H9.525H5.625C4.95 14.3754 4.35 13.7754 4.35 13.1004V1.55039H11.175C11.85 1.55039 12.45 2.15039 12.45 2.82539V7.10039V7.32539C12.825 7.17539 13.2 7.17539 13.65 7.10039C13.2 7.10039 12.825 7.17539 12.45 7.32539C10.725 7.85039 9.45 9.50039 9.45 11.3754C9.45 12.5754 9.9 13.6254 10.65 14.3754C11.1 14.8254 11.625 15.2004 12.225 15.4254C12.675 15.5754 13.2 15.7254 13.65 15.7254C15.975 15.7254 17.925 13.7754 17.925 11.4504C18 9.12539 16.125 7.17539 13.8 7.10039ZM3 8.45039H2.55C1.875 8.45039 1.275 7.85039 1.275 7.17539V2.82539C1.275 2.15039 1.875 1.55039 2.55 1.55039H3V8.45039ZM15.675 11.6754L13.95 13.4004L13.875 13.4754C13.875 13.4754 13.8 13.4754 13.725 13.4754C13.65 13.4754 13.575 13.4754 13.5 13.4004L12.45 12.3504L11.775 11.6754C11.625 11.5254 11.625 11.3754 11.775 11.2254C11.925 11.0754 12.075 11.0754 12.225 11.2254L12.45 11.4504L13.425 12.4254V9.80039C13.425 9.65039 13.575 9.50039 13.725 9.50039C13.875 9.50039 14.025 9.65039 14.025 9.80039V12.4254L15.225 11.2254C15.375 11.0754 15.525 11.0754 15.675 11.2254C15.825 11.3004 15.75 11.5254 15.675 11.6754Z'
        fill='#EF4F5F'
      />
    </svg>
  );
};

export const SingleLineArrow = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='18'
      height='18'
      viewBox='0 0 18 18'
      fill='none'
    >
      <path
        d='M12.1287 8.25163L8.1057 4.22863L9.16635 3.16797L15 9.00163L9.16635 14.8352L8.1057 13.7746L12.1287 9.75163H3V8.25163H12.1287Z'
        fill='white'
      />
    </svg>
  );
};

export const RupeesSignIcon = () => {
  return (
    <div style={{ padding: '5px 5px 0px 3px' }}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='16'
        height='16'
        viewBox='0 0 16 16'
        fill='none'
      >
        <path
          d='M6.0639 9.712L11.1679 16H7.8559L2.3999 9.184V7.888H4.1119C6.0959 7.888 7.5199 7.136 7.8559 5.856H2.3999V4.032H7.8559C7.5199 2.784 6.4159 2.112 4.6879 2.112H2.4159V0H13.5999V1.968H9.6639L9.6479 2.08C10.3039 2.56 10.6559 3.296 10.7679 4.032H13.5999V5.856H10.7519C10.3199 8.048 8.1919 9.408 6.0639 9.712Z'
          fill='#293142'
        />
      </svg>
    </div>
  );
};

export const RupeesSignIconWithCircle = () => {
  return (
    <div style={{ padding: '5px 5px 0px 0px' }}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='20'
        height='20'
        viewBox='0 0 18 18'
        fill='none'
      >
        <circle
          cx='8.99976'
          cy='8.99878'
          r='8.01831'
          stroke='#293142'
          strokeWidth='1.5'
        />
        <path
          d='M5.85699 5.71879H5.72564C5.4495 5.71879 5.22564 5.49493 5.22564 5.21879V4.69531C5.22564 4.41917 5.4495 4.19531 5.72564 4.19531H12.2881C12.5643 4.19531 12.7881 4.41917 12.7881 4.69531V5.20506C12.7881 5.4812 12.5643 5.70506 12.2881 5.70506H10.3039C10.432 5.92466 10.5326 6.18544 10.6058 6.48739H12.2881C12.5643 6.48739 12.7881 6.71124 12.7881 6.98739V7.49713C12.7881 7.77328 12.5643 7.99713 12.2881 7.99713H10.6333C10.5418 8.44548 10.3588 8.84808 10.0843 9.20493C9.69999 9.66243 9.18759 9.97811 8.54709 10.152C8.19939 10.2618 7.76019 10.3304 7.22949 10.3578L9.51219 12.9741C9.7944 13.2975 9.56469 13.8028 9.13544 13.8028H8.45864C8.31426 13.8028 8.17693 13.7404 8.08198 13.6316L5.33868 10.4893C5.25709 10.3959 5.21316 10.2754 5.21542 10.1514L5.23038 9.32869C5.23524 9.06103 5.46576 8.84808 5.73346 8.84808C5.91646 8.85723 6.19096 8.86181 6.55696 8.86181C7.23406 8.86181 7.76019 8.80691 8.13534 8.69711C8.49219 8.60561 8.74839 8.45921 8.90394 8.25791C8.96799 8.17556 9.01831 8.08863 9.05491 7.99713H5.72564C5.4495 7.99713 5.22564 7.77328 5.22564 7.49713V6.98738C5.22564 6.71124 5.4495 6.48739 5.72564 6.48739H9.01374L8.89021 6.30896C8.72551 6.11681 8.46016 5.96584 8.09416 5.85604C7.75561 5.77369 7.30269 5.72336 6.73539 5.70506H6.39226C6.15436 5.70506 5.97594 5.70964 5.85699 5.71879Z'
          fill='#293142'
        />
      </svg>
    </div>
  );
};

export const UserProfileIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='18'
      height='18'
      viewBox='0 0 18 18'
      fill='none'
    >
      <path
        d='M3 16.5C3 13.1863 5.68629 10.5 9 10.5C12.3137 10.5 15 13.1863 15 16.5H13.5C13.5 14.0147 11.4853 12 9 12C6.51472 12 4.5 14.0147 4.5 16.5H3ZM9 9.75C6.51375 9.75 4.5 7.73625 4.5 5.25C4.5 2.76375 6.51375 0.75 9 0.75C11.4863 0.75 13.5 2.76375 13.5 5.25C13.5 7.73625 11.4863 9.75 9 9.75ZM9 8.25C10.6575 8.25 12 6.9075 12 5.25C12 3.5925 10.6575 2.25 9 2.25C7.3425 2.25 6 3.5925 6 5.25C6 6.9075 7.3425 8.25 9 8.25Z'
        fill='#293142'
      />
    </svg>
  );
};
